import React, { useState } from 'react';

const UpdateDetail = (props) => {
  const defaultText = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris faucibus egestas nisl non ultricies. Nam sit amet risus urna. Ut elementum dolor eget malesuada vehicula. Nulla efficitur quis leo et semper. Vivamus ut sodales justo. Maecenas nec vehicula dolor. Fusce ut magna rhoncus, luctus orci vel, aliquam est. Morbi pulvinar varius eros quis sodales. Pellentesque dapibus vitae lorem et aliquam. Fusce at nisi maximus, molestie odio non, lacinia purus.";
  return (
    <div className="update-detail" onClick={props.onClick ?? null}>
      <p className="update-title">{props.title}</p>
      <p>{props.text ?? defaultText} </p>
    </div>
  )
}

export default function User(props) {
  const [showCollection, setShowCollection] = useState(true)
  const [updateTitle, setUpdateTitle] = useState("Monthly")

  if (!props.data) return <></>;

  const { data } = props;

  const showMonthlyDetail = () => {
    setUpdateTitle("Monthly")
    setShowCollection(false)
  }

  const showWeeklyDetail = () => {
    setUpdateTitle("Weekly")
    setShowCollection(false)
  }

  const showDaiyDetail = () => {
    setUpdateTitle("Daily")
    setShowCollection(false)
  }

  return (
    <div className="user">
      <div className="title">
        <div className="title-left">
          <button className="back-button" onClick={props.goHome}><img src={"back.png"} alt="back-button" /></button>
        </div>
        <div className="title-main">
          {props.person.dp && <img src={props.person.dp} alt={props.person.name} />}
          {props.person.dp && <span className="spacer-10" />}
          <h1>{props.person.name}</h1>
        </div>
        <div className="title-right">
          <button className="settings-button" onClick={() => { }}><img src={"settings.png"} alt="settings-button" /></button>
        </div>
      </div>
      {showCollection
        ? (
          <div className="update-collection">
            {data.month.update && <UpdateDetail title="Monthly Update" text={data.month.update}/>}
            {data.week.update && <UpdateDetail title="Weekly Update" text={data.week.update}/>}
            {data.day.update && <UpdateDetail title="Daily Update" text={data.day.update}/>}
          </div>
        )
        : (
          <div className="update-list">
            <h4>{updateTitle} Updates</h4>
            {updateTitle === "Monthly" &&
              <>
                <UpdateDetail title="August" />
                <UpdateDetail title="July" />
                <UpdateDetail title="June" />
              </>
            }
            {updateTitle === "Weekly" &&
              <>
                <UpdateDetail title="Aug 28 - Sep 4" />
                <UpdateDetail title="Aug 21 - Aug 28" />
                <UpdateDetail title="Aug 14 - Aug 21" />
                <UpdateDetail title="Aug 7 - Aug 14" />
                <UpdateDetail title="Jul 31 - Aug 7" />
              </>
            }
            {updateTitle === "Daily" &&
              <>
                <UpdateDetail title="Mon, Sep 5" />
                <UpdateDetail title="Sun, Sep 4" />
                <UpdateDetail title="Sat, Sep 3" />
                <UpdateDetail title="Fri, Sep 2" />
                <UpdateDetail title="Thu, Sep 1" />
                <UpdateDetail title="Wed, Aug 31" />
                <UpdateDetail title="Tue, Aug 30" />
              </>
            }
          </div>
        )
      }
    </div>
  )
}
